<div class="profile-field-box">
  <div class="field-row" [ngClass]="{ 'without-label': !label }">
    <div>
      <label *ngIf="label">{{ label }}</label>
      <p>{{ content ? content : '-' }}</p>
    </div>
    <ng-container *ngIf="showEdit">
      <div class="edit-btn" (click)="clickEditButton()" *ngIf="screen">
        <span class="icon-i-edit"></span>
      </div>
    </ng-container>
  </div>
</div>
